module.exports = __webpack_public_path__ + "img/bold-icon-sm add blue.02e42e7b.svg";